export enum SelectedPosition {
  LEFT = 'left',
  RIGHT = 'right',
  TEXT = 'none',
  FULLWIDTH = 'full'
}